// extracted by mini-css-extract-plugin
export default {"markdownEditor":"markdownEditor___yDFpm"};